export const batches = (state) => Object.values(state.list || {});
export const companyBranchesState = (state) => ({
  ...state.companyBranches,
  list: state.companyBranches.list
    .sort(({ label: a }, { label: b }) => a.localeCompare(b))
});
export const legalQualities = (state) => ({
  ...state.legalQualities,
  list: state.legalQualities.list
    .sort(({ label: a }, { label: b }) => a.localeCompare(b))
});
export const batchClassification = (state) => ({
  ...state.batchClassification,
  list: state.batchClassification.list
    .sort(({ label: a }, { label: b }) => a.localeCompare(b))
});
export const selectedBatch = (state) => (state.selectedBatch);
export const pagination = (state) => (state.pagination);
export const detailsSelectedBatches = (state) => (state.detailsSelectedBatches);
export const loading = (state) => state.loading;
